module.exports = __webpack_public_path__ + "img/logo.1a5921c2.png";